module.exports = __webpack_public_path__ + "static/media/robotAvatar.a5139193.svg";